import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { EnvironmentService } from '@services/environment/environment.service';
import { ToastService } from '@services/toast/toast.service';
import { ToastTypesEnum } from '@models/enums';

import { IS_SERVER } from '@core/config';

@Injectable({ providedIn: 'root' })
export class GlobalSpsErrorHandler implements ErrorHandler {
  constructor(@Inject(IS_SERVER) private isServer: boolean, private toastService: ToastService) {}

  static log(error: string, originalError?: Error): void {
    // if (EnvironmentService.isProdLive) {
    //   return;
    // }

    console.group('--- ERROR CAUGHT IN GLOBAL ERROR HANDLER ---');
    console.log('--- ERROR CAUGHT IN GLOBAL ERROR HANDLER ---: ', error, originalError);
    console.groupEnd();
  }

  // Add logging etc. here...
  public handleError(error: Error | string | HttpErrorResponse) {
    // if (EnvironmentService.isProdLive && !this.isServer) {
    //   return;
    // }

    // @ts-ignore
    const msg = error.error?.message || error.message || error.cause || error.toString();

    GlobalSpsErrorHandler.log(msg);

    if (EnvironmentService.isProdLive) {
      return;
    }

    this.toastService.showToast(msg, ToastTypesEnum.ERROR);
  }
}
